


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import {AloForgottenPass, getDefaultAloForgottenPass} from '@/models/alo/AloForgottenPass'
import * as rules from '@/utils/validationRules'

@Component({
  name: 'CreatePassword',  
})
export default class CreatePassword extends Vue {
  
  private modified = getDefaultAloForgottenPass()
  private dirtyEmail = false
  private dirtyPwd = false    
  private newPassVerif = ""
  private loading = false

  created(){
    this.modified = {
      ...getDefaultAloForgottenPass(),
      userEncryptedToken:this.$route.query.token as string || '',
      userEmail:this.$route.query.email as string || '',
      userLogin:this.$route.query.login as string || '',
    }
  }
  
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }
  rulePasswordMinLength(v:string) {
    return rules.rulePasswordMinLength(v)
  }
  rulePasswordMatch(v:string) {    
    return rules.rulePasswordMatch(v,this.modified.userNewPass)
  }
  ruleMailValid(v:string) {    
    return rules.ruleMailValid(v)
  }

  get authStatus() {
    switch(this.$store.myGetters.authStatus){
      case "CreatePasswordProgress":
        return "Modification en cours"        
      case "CreatePasswordSuccess":
        return "Modification réussie"        
      case "CreatePasswordError":
        return "Erreur de modification : "              
      default:
        return this.$store.myGetters.authStatus        
    }
  }

  get redirectPath(){
    this.modified.userEmail
    return this.$store.myGetters.redirectPath
  }

  beforeDestroy() {

  }
  
  @Watch("dirtyEmail")
  dirtyEmailChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.userName.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }

  @Watch("dirtyPwd")
  dirtyPwdChanged(newValue:boolean) {
    //@ts-ignore
    if(newValue)  this.$refs.newPassword.$el.getElementsByClassName('v-label')[0].classList.add('v-label--active')
  }
  
  mounted(){
    this.hackToSolveAutoFillIssue()  
    this.$store.myActions.AUTH_RESET_STATUS()
  }

  hackToSolveAutoFillIssue(){
    let times = 0;
    const interval = setInterval(() => {
      times += 1
      if ((this.dirtyEmail && this.dirtyPwd) || times === 30) {
        clearInterval(interval)
      }
      else{
        this.dirtyEmail = !!document.querySelector('input[name="UserName"]:-webkit-autofill')
        this.dirtyPwd = !!document.querySelector('input[name="NewPassword"]:-webkit-autofill')
      }
    }, 100)
  }   
  
  submit() {     
    if ((this.$refs.createPasswordForm as HTMLFormElement).validate()) {
      this.loading = true          
      this.$store.myActions.AUTH_CREATE_PASSWORD_REQUEST(this.modified)
      .then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE("Mot de passe modifié avec succès.")
        this.$router.push(this.redirectPath)
         /*this.$store.myActions.AUTH_REQUEST({ userLogin:this.modified.userLogin, userPass:this.modified.userPass }).then(() => {                    
          
        }).finally(() => {
          this.loading = false
        }) */         
      })
      .finally(() => {
        this.loading = false
      })    
    }
  }
}
